import { AbstractControl } from '@angular/forms';

const CUSTOM_TIME_REGEXP_PATTERN = new RegExp("^([0-9]{1,3}):(([0-5]{1}[0-9]{1})|([0-5]{1}))$");

export const customTimeOnly = (control: AbstractControl): object | null => {
  const timeString: string = control.value;
  let validatorObj;
  if (timeString) {
    if (control?.errors?.required) {
      validatorObj = timeString == "" ? { required: true } :
        (CUSTOM_TIME_REGEXP_PATTERN.test(timeString)) ? null : { invalid: true };
    }
    else {
      validatorObj = timeString == "" ? null :
        (CUSTOM_TIME_REGEXP_PATTERN.test(timeString)) ? null : { invalid: true };
    }
  }
  return validatorObj;
}